'use strict';

function controller($attrs, bookingService) {
    const vm = this;

    vm.loading = true;

    vm.bookingStatus = null;
    vm.bookingStatusClass = null;
    vm.bookingLink = null;
    vm.bookingMessage = null;
    vm.hideBookButton = null;
    vm.priceDescription = null;
    vm.hidePriceDescription
    vm.subscriptions = null;
    vm.isBookable = null;
    vm.error = false;

    const prodSeasonNo = parseInt($attrs.prodSeasonNo, 10);
    const perfNo = parseInt($attrs.perfNo, 10);
    const seasonContent = $attrs.seasonContent;

    vm.init = () => {
        bookingService.getDetails(
            prodSeasonNo, perfNo, seasonContent
        ).then(details => {
            vm.bookingStatus = details.bookingStatus;
            vm.bookingStatusClass = details.bookingStatusClass;
            vm.bookingLink = details.bookingLink;
            vm.bookingMessage = details.bookingMessage;
            vm.hideBookButton = details.hideBookButton;
            vm.priceDescription = details.priceDescription;
            vm.hidePriceDescription = details.hidePriceDescription;
            vm.subscriptions = details.subscriptions;
            vm.isBookable = details.isBookable;
        }).catch(e => { // eslint-disable-line no-unused-vars
            vm.error = true;
        }).finally(() => {
            vm.loading = false;
        });
    }

    return vm;
}

module.exports = [
    '$attrs', 'bookingService', controller,
];



// WEBPACK FOOTER //
// ./widgets/controllers/BookButton.js